import axios from 'axios';

import settings from './settings';

/**
 * Class representing Anime GIF source.
 */
class Anime {
  /**
   * Create an Anime GIF source.
   * @param {string} id - Video Media ID.
   */
  constructor(id) {
    this.id = id;
    this.baseUrl = settings.animeBaseUrl;
    this.timeout = settings.timeout;
    this.HEADStatus = 404;
  }

  /**
   * Check if Anime GIF URL is valid.
   */
  check() {
    return new Promise(resolve => {
      axios.head(this.url, {
        timeout: this.timeout,
      })
        .then(result => {
          this.HEADStatus = result.status;
          resolve(this.hasGIF);
        })
        .catch(() => resolve(false));
    });
  }

  /**
   * Return Anime GIF check status.
   * @return {boolean}
   */
  get hasGIF() {
    return this.HEADStatus === 200;
  }

  /**
   * Return GIF URL.
   */
  get url() {
    return `${this.baseUrl}/${this.id}.gif`;
  }
}

export default Anime;



// WEBPACK FOOTER //
// ./src/Anime.js